import { X } from "lucide-react";
import CustomInput from "../../shared/CustomInput";
import Loading from "../../shared/Loading";

const AddBranch = ({
  closeAddBranch,
  branchDetails,
  setBranchDetails,
  errors = {},
  clearError,
  handleAddBranch,
  loading,
}) => {
  return (
    <div
      onClick={(e) => {
        closeAddBranch();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[850px] h-[400px] rounded-[10px] p-[20px] relative bg-white"
      >
        <div
          onClick={closeAddBranch}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <div className="absolute bottom-[10px] right-[20px]">
          <button
            disabled={loading}
            onClick={handleAddBranch}
            className="h-[35px] bg-[#000000] flex items-center justify-center gap-[5px] rounded-[30px] px-[15px] text-[15px] font-bold text-white"
          >
            {loading && <Loading />}
            Next
          </button>
        </div>
        <div>
          <p className="text-[#000000] font-semibold text-[20px]">
            Add a New Branch
          </p>
          <p className="text-[#5C5C5C] text-[15px] font-normal">
            Provide details to create a new branch
          </p>
          <div className="flex flex-col gap-[20px] mt-[20px]">
            {/* Branch Name */}
            <div className="flex w-[100%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="name"
              >
                Branch Name
              </label>
              <CustomInput
                placeholder="Enter branch name"
                type="text"
                value={branchDetails.name}
                onChange={(e) => {
                  setBranchDetails({ ...branchDetails, name: e.target.value });
                  clearError?.("name");
                }}
              />
              {errors?.name && (
                <p className="text-red-500 text-xs mt-1">{errors.name}</p>
              )}
            </div>

            {/* City */}
            <div className="flex w-[100%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="city"
              >
                City
              </label>
              <CustomInput
                placeholder="Enter city"
                type="text"
                value={branchDetails.city}
                onChange={(e) => {
                  setBranchDetails({ ...branchDetails, city: e.target.value });
                  clearError?.("city");
                }}
              />
              {errors?.city && (
                <p className="text-red-500 text-xs mt-1">{errors.city}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddBranch;
